export function downloadExcel(base64: string, fileName = "file.xlsx") {
  if (!base64) {
    throw new Error("Base64 string is empty");
  }

  const formatBase64 = base64.split(",")[1] || base64;

  // Decodificar base64 a binario
  const binaryString = atob(formatBase64);

  // Crear un array de bytes
  const byteNumbers = new Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteNumbers[i] = binaryString.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  // Crear un Blob con el tipo MIME para Excel
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  // Crear un enlace temporal para descargar el archivo
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;

  // Hacer clic en el enlace para iniciar la descarga
  document.body.appendChild(link);
  link.click();

  // Limpiar el DOM
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
